import { Fragment } from "react"
import {
  EstimatesArrow as Arrow,
  Box,
  EstimatesContainer as Container,
  EstimatesDivider as Divider,
} from "../../../../components/elements"
import { theme } from "../../../../themes/theme"
import { IEstimateItem, IEstimates } from "../../../platform/types"
import {
  Cell,
  HeaderRow,
  Label,
  ResultRow,
  Row,
  RowHeader,
  Spacer,
  Unit,
  Value,
  ValueAndUnit,
} from "./styles"
interface IEstimateProps {
  results: IEstimates
}

const HOURS_PER_YEAR = "時間/年"
const YEN_PER_YEAR = "円/年"
const RESULT_LABELS: { [key in keyof IEstimates]: string } = {
  device: "デバイスの見積もり/購入・廃棄/下取り・台帳更新",
  saas: "SaaS アカウント発行・削除・台帳更新",
  inventory: "デバイス・SaaSアカウントの棚卸し",
  unused_accounts: "未利用アカウントの検知・削除",
  total: "ジョーシス導入後の削減コスト合算",
}

const formatHours = (minutes: number) => {
  return Math.round(minutes / 60).toLocaleString()
}
const Estimates = (props: IEstimateProps) => {
  const { results } = props

  return (
    <Container>
      <HeaderRow $coloredBackground $header>
        <Box justifyContent="flex-start">作業内容</Box>
        <Spacer />
        <Cell>削減時間</Cell>
        <Spacer />
        <Cell>削減コスト</Cell>
      </HeaderRow>
      {Object.keys(RESULT_LABELS)
        .filter((key) => key !== "total")
        .map((key, i) => (
          <Fragment key={key}>
            <Row $coloredBackground>
              <RowHeader>作業内容</RowHeader>
              <Label>{RESULT_LABELS[key as keyof IEstimates]}</Label>
              <Spacer />

              <RowHeader>削減時間</RowHeader>
              <Cell>
                {key === "unused_accounts" ? (
                  `-`
                ) : (
                  <ValueAndUnit>
                    <Value>
                      {formatHours(
                        (results[key as keyof IEstimates] as IEstimateItem)
                          .minutes
                      )}
                    </Value>
                    <Unit>{HOURS_PER_YEAR}</Unit>
                  </ValueAndUnit>
                )}
              </Cell>
              <Spacer />

              <RowHeader>削減コスト</RowHeader>
              <Cell>
                <ValueAndUnit>
                  <Value>
                    {results[key as keyof IEstimates].cost.toLocaleString()}
                  </Value>
                  <Unit>{YEN_PER_YEAR}</Unit>
                </ValueAndUnit>
              </Cell>
            </Row>
            {i < Object.keys(RESULT_LABELS).length - 2 && (
              <Divider
                bgColor={theme.colors.bodyBackground as "bodyBackground"}
              />
            )}
          </Fragment>
        ))}
      <Arrow />
      <ResultRow>
        <Label>{RESULT_LABELS.total}</Label>
        <Spacer />
        <Cell>
          <ValueAndUnit>
            <Value $lg>{formatHours(results.total.minutes)}</Value>
            <Unit>{HOURS_PER_YEAR}</Unit>
          </ValueAndUnit>
        </Cell>
        <Spacer />
        <Cell>
          <ValueAndUnit>
            <Value $lg>{results.total.cost.toLocaleString()}</Value>
            <Unit>{YEN_PER_YEAR}</Unit>
          </ValueAndUnit>
        </Cell>
      </ResultRow>
    </Container>
  )
}

export { Estimates }
